"use client";
import { useScrollToTop } from "@/hooks";
import { PanelLayout } from "./Layout/PanelLayout";
import { PanelTitle } from "./Layout/PanelTitle";
import { useTranslations } from "next-intl";
import { Faq } from "./Faq";
import { ToggleGroup } from "./ToggleGroup";
import { WebHostingPlans } from "./WebHostingPlans";
import { WHPanelContent } from "./WHPanelContent";
import { BlogListWithTags } from "./Blog/BlogListWithTags";

export const WebHosting = () => {
  useScrollToTop();
  const t = useTranslations();
  const toggleItems = [
    {
      id: "monthly",
      text: t("monthly"),
    },
    {
      id: "yearly",
      text: t("yearly"),
    },
  ];

  return (
    <div>
      <PanelLayout extraclassName="items-center">
        <WHPanelContent page={"web_hosting"}/>
      </PanelLayout>
      <main className="flex justify-center flex-col my-32  items-center mx-auto max-w-[1296px] px-2">
        <PanelTitle sectionName="web_hosting_table" colourGroup="blackGroup" />
        <div className="mb-8">
          <ToggleGroup {...{ toggleItems }} type="webHosting" />
        </div>
        <WebHostingPlans />
      </main>
      <PanelLayout>
        <PanelTitle sectionName="any_question" posGroup="left" />
      </PanelLayout>
      <section className="py-32">
        <PanelTitle sectionName="faq_hosting" colourGroup="blackGroup" bt />
        <Faq type="Web Hosting" />
      </section>
      <section>
        <BlogListWithTags filterTags={["hostinq", "hosting"]} />
      </section>
    </div>
  );
};
